
import { useState } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Container } from "react-bootstrap";
import { NavBarTest } from '../../../components/NavBarTest';
import {
   RegisterCards,
   SponsorsSectionNew,
   StatsBanner,
   VideoSection,
   TracksWeb,
   TestimonialCarousel,
   Investors,
   LogoCarouselTest,
} from "../components/index";
import { FooterNew } from '../../../components/index';


export const Home = () => {
   document.title = "Venture Summit Digital Connect | Overview";
   const [imageLoaded, setImageLoaded] = useState(false)

   return (
      <div style={{ backgroundColor: '#212529 !important' }}>
         <NavBarTest />

         <Container
            fluid
            style={{
               height: "auto",
               padding: 0,
               position: 'relative',
            }}
         >
            {imageLoaded ? <img
               alt='banner'
               src={window.innerWidth < 769 ? "./assets/media/Group 138.png" : "./assets/media/Group 136 (1).png"}
               loading="eager"
               style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "auto",
               }}
            /> : <Skeleton><img
               alt='banner'

               src={window.innerWidth < 769 ? "./assets/media/Group 138.png" : "./assets/media/Group 136 (1).png"}
               loading="eager"
               style={{
                  objectFit: "cover",
                  width: "100%",
                  height: "auto",
               }}
            /></Skeleton>}
            <div style={{ position: 'relative' }}>
               <span
                  className="banner-text"
                  style={{
                     position: "absolute",
                     color: "white",
                     fontFamily: "Roboto Condensed, sans-serif !important",
                     fontSize: "2.5rem",
                     fontWeight: "900",
                     top: "22.5%",
                     textShadow: "2px 2px 4px #000000",
                     width: "100%",
                     left: "0",
                     right: "0",
                     textAlign: "center",
                  }}
               >


               </span>
            </div>
            <span
               className="banner-text"
               style={{
                  position: "absolute",
                  color: "white",
                  fontFamily: "Roboto Condensed, sans-serif !important",
                  fontSize: "2.5rem",
                  fontWeight: "900",
                  top: "27.5%",
                  textShadow: "2px 2px 4px #000000",
                  width: "100%",
                  left: "0",
                  right: "0",
                  textAlign: "center",
               }}
            >
               <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', width: 'fit-content', margin: 'auto', gap: '25px' }}>
                  <div>
                     <img
                        alt='banner'
                        className="west22-logo" loading="eager" style={{ maxWidth: '600px' }}
                        src={'./assets/media/VSDC White 1.png'}
                     /></div>
                  <h4 style={{ fontSize: window.innerWidth < 769 && "1rem" }}>March 29th - 31st 2022 | Online</h4>

               </div>
            </span>


         </Container>
         <StatsBanner />
         <img
            alt='banner'
            style={{ width: '100%' }} onLoad={e => setImageLoaded(true)} loading="eager" src={window.innerWidth < 1000 ? './assets/media/single-quote-testimonial-mobile.png' : './assets/media/single-quote-testimonial.png'} />
         <Investors />
         <VideoSection />
         <RegisterCards />
         <TracksWeb />
         {window.innerWidth > 900 && <LogoCarouselTest />}
         {window.innerWidth > 900 && <TestimonialCarousel />}
         <SponsorsSectionNew />
         <FooterNew />
      </div>
   );
};
